<template>
  <i class="tm-visual-badge">
    <i v-if="showOverlayNumber" class="-top">
      <i class="-overlays" v-text="`+${overlays}`" :title="overlaysTitle" />
    </i>

    <i class="-bottom">
      <i class="-duration">
        <i v-if="trackIcon" :class="`wticon ${trackIcon}`" />
        <i class="t" v-text="trackDuration" />
      </i>

      <i v-if="videoSpeed" class="-speed" v-text="videoSpeed" />

      <i v-if="showVolume" class="-volume">
        <i v-if="isVolumeMuted" class="-muted wticon wticon-mute" />
        <i v-else class="-unmuted wticon wticon-volume-medium2" />
      </i>

      <i v-if="isTracking" class="-tracking" :title="trackingTitle">
        <wt-google-like-loader class="-default" />
        <i class="t" v-text="'Tracking objects...'" />
      </i>
    </i>
  </i>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import {
  getAssetVideoSpeed,
  getTrackIcon,
  isVisualAssetMuted,
} from '../../../api/asset';
import { trackTimeFormat } from '../../../api/tapi';
export default {
  name: 'tm-visual-badge',

  props: {
    track: { type: Object, required: true },
    isSceneEdit: { type: Boolean, required: true },
  },

  computed: {
    ...mapState('timemachine', {
      MODE_SCENE_EDIT: (state) => state.MODE.SCENE_EDIT,
    }),
    ...mapGetters('timemachine', ['shouldShow_TrackLayerAudio']),

    trackIcon() {
      return getTrackIcon(this.$props.track.data);
    },

    showOverlayNumber() {
      return this.overlays > 0 && !this.$props.isSceneEdit;
    },

    overlays() {
      return this.$props.track.pipa.track.length;
    },

    overlaysTitle() {
      return `${this.overlays} Asset${this.overlays > 1 ? 's' : ''} inside`;
    },

    trackDuration() {
      return trackTimeFormat(this.$props.track.data.displayDuration);
    },

    videoSpeed() {
      return getAssetVideoSpeed(this.$props.track.data);
    },

    showVolume() {
      return this.$props.track.data.hasValidAudio;
    },

    isVolumeMuted() {
      return isVisualAssetMuted(
        this.$props.track.data,
        this.shouldShow_TrackLayerAudio
      );
    },

    isTracking() {
      return this.$props.track.trackingState.show;
    },

    trackingTitle() {
      return 'Tracking objects, the preview will refresh when it is done';
    },
  },
};
</script>

<style lang="scss">
.tm-visual-span .tm-visual-badge {
  position: absolute;
  top: 0;
  z-index: var(--tm-zVisualBadge);
  overflow: hidden;
  pointer-events: none;

  > .-top {
    position: absolute;
    top: var(--tm-pxVisualSpanBorder);
    left: var(--tm-pxVisualSpanBorder);

    > .-overlays {
      pointer-events: all;
      padding: 5px 6px;
      background-color: #20bc9c;
      color: #fff;
      font-size: 14px;
      line-height: 1;
    }
  }

  > .-bottom {
    position: absolute;
    left: var(--tm-pxVisualSpanBorder);
    bottom: var(--tm-pxVisualSpanBorder);
    display: flex;
    justify-content: center;
    align-items: stretch;
    height: 24px;
    pointer-events: none;

    > .-duration {
      display: flex;
      align-items: center;
      padding: 0 7px;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;

      > .wticon {
        font-size: 16px;
        line-height: 0;
        &:before {
          color: #fff;
        }

        &.wticon-instagram-location {
          top: 4px;
          font-size: 24px;
          margin-right: -9px;
          margin-left: -6px;
        }
      }

      > .t {
        font-size: 12px;
        margin-top: 2px;
      }

      > .wticon + .t {
        margin-left: 8px;
      }
    }

    > .-speed {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      margin-left: 2px;
      padding: 3px 7px 0 7px;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
    }

    > .-volume {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
      width: 26px;
      height: 24px;
      margin-left: 2px;

      > .-muted {
        font-size: 20px;
        //font-weight: bold;
        transform: translateX(5px);
      }
      > .-unmuted {
        font-size: 16px;
        transform: translateX(2px);
      }
    }

    > .-tracking {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
      height: 24px;
      margin-left: 2px;
      padding: 0 7px;
      pointer-events: all;

      // smaller and white - the shared `-default` is 22px green
      .wt2-google-like-loader.-default {
        width: 16px;
        flex: 0 0 auto;

        svg circle {
          stroke: #fff;
        }
      }

      > .t {
        font-size: 12px;
        margin-left: 6px;
        white-space: nowrap;
      }
    }
  }
}
</style>
